module.exports = __webpack_public_path__ + "img/iea-logo.fc4c5f68.png";